export default "__VITE_ASSET__D6bP187n__"